<template>
  <div class="wrapper" style="height: 100%">
    <div style="position: relative">
      <div v-if="!isProxy">
        <Proxy />
      </div>
      <div v-else class="bg-bg-common-color p-4 relative" style="min-height: calc(100vh - 120px);">
        <div class="bg-white p-4">
          <el-input
            size="small"
            class="mb-3"
            placeholder="调查员手机号"
            prefix-icon="el-icon-search"
            @blur="searchValue"
            v-model="search_phone"
            style="width: 200px"
          >
          </el-input>
          <data-table
            style="width: 100%"
            ref="crud"
            :columns="option_Dl.column"
            :data="
              data_Dl.map((item) => {
                return item.task;
              })
            "
            :page="page_Dl"
            :showPage="true"
            :loading="tableLoading_Dl"
            :index="true"
            :selection="true"
            :expand="true"
            :defaultExpandAll="true"
            rowKey="taskId"
            @size-change="sizeChange_Dl"
            @pagination-current-change="currentChange_Dl"
          >
            <template #taskStatus="{ row }">
              <el-tooltip
                class="item"
                effect="light"
                :content="statusTip(getstatus(row, 'text'))"
                placement="top"
              >
                <el-tag :type="getstatus(row, 'type')">{{
                  getstatus(row, "text")
                }}</el-tag>
              </el-tooltip>
            </template>
            <!-- <template #executionRequirement="{ row }">
              <el-tooltip
                placement="top"
                effect="light"
                v-if="
                  row.executionRequirement && row.executionRequirement.length > 6
                "
              >
                <div slot="content">{{ row.executionRequirement }}</div>
                <div>{{ row.executionRequirement.substring(0, 6) + "..." }}</div>
              </el-tooltip>
              <span
                v-if="
                  row.executionRequirement && row.executionRequirement.length < 6
                "
                >{{ row.executionRequirement }}</span
              >
            </template> -->
            <template #opt="{ row }">
              <el-button type="text" @click="sendTask(row)">
                分配任务
              </el-button>
              <el-popover placement="left" trigger="click" width="150px">
                <div>
                  <el-button type="text" style="width: 150px; margin-bottom: 10px;"
                  @click="batchOpenTask"
                    >批量开启</el-button
                  >
                  <br />
                  <el-button type="text" style="width: 150px;" @click="batchCloseTask"
                    >批量关闭</el-button
                  >
                </div>
                <el-button
                  type="text"
                  style="margin-left: 5px;"
                  @click="taskAmount(row)"
                  slot="reference"
                  >批量开/关任务</el-button
                >
              </el-popover>
            </template>
            <template #expand="{ row, $index }">
              <div class="flex items-center justify-center" style="background: white;height: 36px;" v-if="!data_Dl[$index].executionList||data_Dl[$index].executionList.length==0">
                <div>暂无数据</div>
              </div>
              <div v-else class="px-3 py-2">
                <data-table
                  ref="crud_child"
                  :columns="option_Dl_child.column"
                  :data="data_Dl[$index].executionList"
                  :index="true"
                  :selection="true"
                  :page="page_Dl_child"
                  @on-load="changeRow(row)"
                  @selection-change="selectionChange_Dl_child"
                >
                  <!-- <template #executionDescription="{ row }">
                    <el-tooltip
                      placement="top"
                      effect="light"
                      v-if="
                        row.executionDescription &&
                        row.executionDescription.length > 6
                      "
                    >
                      <div slot="content">{{ row.executionDescription }}</div>
                      <div>
                        {{ row.executionDescription.substring(0, 6) + "..." }}
                      </div>
                    </el-tooltip>
                    <span
                      v-if="
                        row.executionDescription &&
                        row.executionDescription.length < 6
                      "
                      >{{ row.executionDescription }}</span
                    >
                  </template> -->
                  <template #status="{ row }">
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="statusTip1(getstatus_child(row, 'text'))"
                      placement="top"
                    >
                      <el-tag :type="getstatus_child(row, 'type')">{{
                        getstatus_child(row, "text")
                      }}</el-tag>
                    </el-tooltip>
                  </template>
                  <template #opt="{ row }">
                    <el-button
                      type="text"
                      @click="seeTask(row)"
                    >
                      查看
                    </el-button>
                    <el-button
                      v-if="row && row.status && row.status !== 7"
                      type="text"
                      @click="changeTask(row,0,'关闭')"
                    >
                      关闭
                    </el-button>
                    <el-button
                      v-if="row && row.status && row.status == 7"
                      type="text"
                      @click="changeTask(row,1,'开启')"
                    >
                      开启
                    </el-button>
                  </template>
                </data-table>
              </div>
            </template>
          </data-table>

          <el-dialog title="批量开启任务" :visible.sync="box" width="30%">
            <p>
              当前选中<span class="task">
                {{ this.taskArr_Dl == null ? 0 : this.taskArr_Dl.length }} </span
              >个任务，确认全部开启吗？开启后调查员可继续执行任务。
            </p>
            <span slot="footer" class="dialog-footer">
              <el-button @click="box = !box">取 消</el-button>
              <el-button type="primary" @click="taskOpenConfirm">确 定</el-button>
            </span>
          </el-dialog>
          <el-dialog title="批量关闭任务" :visible.sync="box1" width="30%">
            <p>
              当前选中<span class="task">
                {{ this.taskArr_Dl == null ? 0 : this.taskArr_Dl.length }} </span
              >个任务，确认全部关闭吗？关闭后调查员将不能执行该任务。
            </p>
            <span slot="footer" class="dialog-footer">
              <el-button @click="box1 = !box1">取 消</el-button>
              <el-button type="primary" @click="taskCloseConfirm"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
    <el-drawer
      title="分配任务"
      :visible.sync="zAssignTaskDrawer"
      size="70%"
      :destroy-on-close="true"
      :before-close="handleZAssignTaskDrawerClose">
        <ZAssignTask :entrustTaskId="curEntrustTaskId" @cancel="handleZAssignTaskDrawerClose"></ZAssignTask>
    </el-drawer>
    <el-drawer
      title="查看"
      :visible.sync="showTaskDrawer"
      size="60%"
      :destroy-on-close="true"
      :before-close="handleShowTaskDrawerClose">
        <ShowTask @cancel="handleShowTaskDrawerClose" :rows="curRows"></ShowTask>
    </el-drawer>
  </div>
</template>

<script>
import {
  agencyListDl,
  list4Entrust,
  batchOpenOrClose4Entrust,
} from "@/api/wenjuan/publishQuestion";
import { extendObject } from "@/assets/js/utils";
import Proxy from './Proxy.vue';
import DataTable from '@/components/base/DataTable'
import GlobalConfig from "@/global/config"
import { mapGetters } from 'vuex'
import ZAssignTask from './components/task/ZAssignTask'
import ShowTask from '@/views/survey/offline/components/task/ShowTask'
import { getDomain } from '@/assets/js/config/env'
// import { getStore } from '@dygc/shared';

const statusType = {
  3: {
    type: "warning",
    text: "待承接",
  },
  4: {
    type: "primary",
    text: "已承接",
  },
  5: {
    type: "danger",
    text: "已拒绝",
  },
  6: {
    type: "danger",
    text: "已关闭",
  },
  7: {
    type: "success",
    text: "已完成",
  },
};
const statusType_child = {
    6: {
      type: 'danger',
      text: '已分配',
    },
    7: {
      type: 'info',
      text: '已关闭',
    },
    9: {
      type: 'warning',
      text: '邀请中',
    },
    10: {
      type: 'success',
      text: '已邀请',
    },
    11: {
      type: 'primary',
      text: '已承接',
    },
    12: {
      type: 'warning',
      text: '已拒接',
    },
    13: {
      type: 'primary',
      text: '已完成',
    }
};
export default {
  name: "ProxyExecution",
  components: {
    Proxy,DataTable,ZAssignTask,ShowTask
  },
  data() {
    return {
      zAssignTaskDrawer: false,
      showTaskDrawer: false,
      curRows: {},
      curEntrustTaskId: '',
      url:
        getDomain() +
        "/entrustexe?token=" +
        GlobalConfig.getBaseToken(),
      taskUrl: process.env.VUE_APP_TASK_HALL_DOMAIN + '?token=' + GlobalConfig.getBaseToken()
        + '&companyid=' + GlobalConfig.getCompanyId(),
      tableLoading: false,
      tableLoading_Dl: false,
      dialogVisible: false,
      dialogVisible2: false,
      visible: false,
      data: [],
      data_proxy: [],
      search_phone: "",
      checked: false,
      box: false,
      box1: false,
      taskArr: [], //已勾选的代理
      taskArr_Dl: [], //有代理方时 勾选的任务
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50, 100],
      },
      page_Dl: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50, 100],
      },
      option_Dl: {
        column: [
          {
            label: "任务ID",
            value: "taskId",
            width: 60,
            name: "taskId",
          },
          {
            label: "任务状态",
            value: "taskStatus",
            width: 100,
            name: "taskStatus",
          },
          {
            label: "任务名称",
            value: "taskName",
            width: 120,
            name: "taskName",
          },
          {
            label: "截止时间",
            value: "endTime",
            width: 150,
            name: "endTime",
          },
          {
            label: "承接时间",
            value: "acceptTime",
            width: 150,
            name: "acceptTime",
          },
          {
            label: "答卷数量",
            value: "requireCount",
            // width: "80px",
            name: "requireCount",
          },
          {
            label: "答卷单价（元）",
            value: "unitPrice",
            name: "unitPrice",
          },
          {
            label: "执行要求",
            value: "executionRequirement",
            // width: "80px",
            name: "executionRequirement"
          },
          {
            label: "提交数量",
            value: "submitCount",
            // width: "80px",
            name: "submitCount",
          },
          {
            label: "有效数量",
            value: "effectiveAmount",
            // width: "80px",
            name: "effectiveAmount",
          },
          {
            label: '操作',
            value: 'opt',
            width: 210
          }
        ],
      },
      page_Dl_child: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option_Dl_child: {
        column: [
          {
            label: "任务ID",
            value: "id",
            width: 100,
            name: "id",
          },
          {
            label: "任务状态",
            value: "status",
            // width: "80px",
            name: "status",
          },
          {
            label: "任务名称",
            value: "executionName",
            width: 100,
            name: "executionName",
          },
          {
            label: "调查员手机号",
            value: "executorPhone",
            width: 100,
            name: "executorPhone",
          },
          {
            label: "截止时间",
            value: "executionValidateTo",
            width: 100,
            name: "executionValidateTo",
          },
          {
            label: "承接时间",
            value: "receptTime",
            width: 100,
            name: "receptTime",
          },
          {
            label: "答卷数量",
            value: "executionQuantity",
            // width: "80px",
            name: "executionQuantity",
          },
          {
            label: "答卷单价（元）",
            value: "executionSingleAmount",
            // width: "120px",
            name: "executionSingleAmount",
          },
          {
            label: "任务描述",
            value: "executionDescription",
            width: 80,
            name: "executionDescription",
          },
          {
            label: "提交数量",
            value: "recycledQuantity",
            // width: "80px",
            name: "recycledQuantity",
          },
          {
            label: "有效数量",
            value: "effectiveQuantity",
            // width: "80px",
            name: "effectiveQuantity",
          },
          {
            label: '操作',
            value: 'opt',
            width: 90
          }
        ],
      },
      data_Dl: [],
      data_Dl_child: [],
      tableData: [],
      formInline: {},
      search_phone: "",
      value: "",
    };
  },
  computed: {
    ...mapGetters(['isProxy'])
    /* isProxy() {
      return getStore({name: 'proxy_is_survey_proxy'})
    } */
  },
  methods: {
    handleZAssignTaskDrawerClose() {
      this.zAssignTaskDrawer = false
      this.getProxyDl()
    },
    handleShowTaskDrawerClose() {
      this.showTaskDrawer = false
      this.getProxyDl()
    },
    //代理方 委托代理任务列表数据来源
    getProxyDl() {
      this.tableLoading_Dl = true;
      const p = {
        current: this.page_Dl.currentPage,
        size: this.page_Dl.pageSize,
        surveyId: GlobalConfig.getSurveyId(),
        executorPhone: this.search_phone,
      };
      list4Entrust(p)
        .then((res) => {
          this.page_Dl.total = res.data.data.total;
          this.page_Dl.pageSize = res.data.data.size;
          this.data_Dl = (res.data.data.records || []).map((item) => {
            return item;
          });
          this.tableLoading_Dl = false;
        })
        .catch((err) => {
          console.log(err);
          this.tableLoading_Dl = false;
        });
    },
    // getData_child(row, $index) {
    //   return this.data_Dl.map((item) => {
    //     if (item.executionList) {
    //       return item.executionList.map((item) => {
    //         if (row.taskId == item.entrustTaskId) {
    //           return item;
    //         }
    //       });
    //     }
    //   })[$index];
    // },
    searchValue() {
      // console.log(this.search_phone);
      this.getProxyDl();
    },
    sizeChange_Dl(val) {
      this.page_Dl.currentPage = 1;
      this.page_Dl.pageSize = val;
      this.getProxyDl();
    },
    currentChange_Dl(val) {
      this.page_Dl.currentPage = val;
      this.getProxyDl();
    },
    selectionChange_Dl_child(list) {
      this.taskArr_Dl = list;
      // console.log(this.taskArr_Dl);
    },
    taskOpenConfirm() {
      const id = this.taskArr_Dl.map((item) => {
        return item.id;
      });
      // console.log(id);
      const p = {
        idList: id,
        batchFlag: 1,
      };
      batchOpenOrClose4Entrust(p)
        .then((res) => {
          this.getProxyDl();
          this.box = !this.box;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    taskCloseConfirm() {
      const id = this.taskArr_Dl.map((item) => {
        return item.id;
      });
      const p = {
        idList: id,
        batchFlag: 0,
      };
      batchOpenOrClose4Entrust(p)
        .then((res) => {
          this.getProxyDl();
          this.box1 = !this.box1;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getstatus(row, info) {
      if (info == "type" && row.taskStatus) {
        return statusType[row.taskStatus] && statusType[row.taskStatus].type;
      } else if (info == "text" && row.taskStatus) {
        return statusType[row.taskStatus] && statusType[row.taskStatus].text;
      }
    },
    getstatus_child(row, info) {
      if (info == "type" && row.status) {
        return statusType_child[row.status] && statusType_child[row.status].type;
      } else if (info == "text" && row.status) {
        return statusType_child[row.status] && statusType_child[row.status].text;
      }
    },
    statusTip(r) {
      if (r == "已关闭") {
        return "调查员不能继续执行的任务";
      } else if (r == "已承接") {
        return "对方已承接此任务";
      } else if (r == "已完成") {
        return "已完成结算的任务";
      }else if (r == "已拒绝") {
        return "对方拒绝承接此任务";
      }else if (r == "待承接") {
        return "成功创建的任务";
      }
    },
    statusTip1(r){
        if(r == "已分配"){
          return "成功分配的任务"
        }else if(r == "已关闭"){
          return "调查员不能继续执行的任务"
        }else if(r == "已承接"){
          return "对方已承接此任务"
        }else if(r == "已拒接"){
          return "对方拒绝承接此任务"
        }else if(r == "已完成"){
          return "此任务已完成"
        }else if(r == "邀请中"){
          return "未注册手机号，创建任务成功，没有收到短信发送成功通知的任务"
        }else if(r == "已邀请"){
          return "未注册手机号，创建任务成功，且收到短信发送成功通知的任务"
        }
      },
    sendTask(row) {
      this.curEntrustTaskId = row.taskId
      this.zAssignTaskDrawer = true
      // this.$router.push({
      //   path: `/survey/${GlobalConfig.getSurveyId()}/agency/agency-interview/z-assign-task`,
      //   query: {
      //     entrustTaskId: row.taskId,
      //   }
      // });
    },
    taskAmount() {
      console.log("批量开关任务");
    },
    batchOpenTask() {
      if (this.taskArr_Dl == null || this.taskArr_Dl.length <= 0) {
        this.$message.error("请勾选需要批量处理的任务");
      } else {
        this.box = true;
      }
    },
    batchCloseTask() {
      if (this.taskArr_Dl == null || this.taskArr_Dl.length <= 0) {
        this.$message.error("请勾选需要批量处理的任务");
      } else {
        this.box1 = true;
      }
    },
    seeTask(row) {
      let rows = JSON.parse(JSON.stringify(row));
      rows.offlineId = rows.id;
      rows.rowId = row.id
      delete rows.id;
      let query = {};
      extendObject(query, rows);
      this.curRows = query
      this.showTaskDrawer = true
      // this.$router.push({
      //   path: `/survey/${GlobalConfig.getSurveyId()}/offline/assign-sample-interview/show-task?rowId=${row.id}`,
      //   query,
      // });
    },
    changeTask(row,type,str) {
      this.$confirm("确认"+ str + "当前任务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const id = [];
          id[0] = row.id
          const p = {
            idList: id,
            batchFlag: type,
          };
          batchOpenOrClose4Entrust(p)
            .then((res) => {
              this.getProxyDl();
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // selectionChangeP(list) {
    //   this.taskArr = list;
    // },
    changeRow(row){
      for (let index = 0; index < this.data_Dl.length; index++) {
        if(this.data_Dl[index].task.taskId == row.taskId){
          if(this.data_Dl[index].executionList){
            this.$refs.crud.toggleRowExpansion(row,true)
          }else{
            this.$refs.crud.toggleRowExpansion(row,false)
          }
        }
      }
    },
    proxy_true(value) {
      if (this.taskArr.length <= 0) {
        this.$message.warning("当前未勾选代理");
        this.checked = false;
      }
    },
    // create_push(row) {
    //   this.$router.push({
    //     path: `/survey/${GlobalConfig.getSurveyId()}/agency/agency-interview/create`,
    //     query:{
    //      proxyId: row.proxyId
    //     }
    //   });
    // },
    // task_list_push() {
    //   this.$router.push({
    //     path: `/survey/${GlobalConfig.getSurveyId()}/agency/agency-interview/task-list`,
    //   });
    // },
    // creat_proxy() {
    //     this.$router.push({
    //       path: `/survey/${GlobalConfig.getSurveyId()}/agency/agency-interview/create`,
    //     })
    // },
    goNewPage() {
      window.open(this.taskUrl);
    },
  },
  created() {
    //this.onLoad();
    this.getProxyDl();
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  .buttonTask {
    width: 150px;
    opacity: 0.5;
  }
  .buttonTask:hover {
    opacity: 1;
  }
  .buttonTask1 {
    margin-bottom: 5px;
  }
  .avue_proxy {
    .btn-color {
      color: #227FFE;
      cursor: pointer;
    }
  }
  .flex-box{
    height: calc(100vh - 130px);
    position: relative;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }
  .see_task_list{
    color: rgb(225, 54, 75);
    position: absolute;
    top: 50px;
  }
  .p_proxy {
    font-size: 20px;
    font-weight: bold;
    margin: 20px 0 0 20px;
  }
  .empty {
    width: 640px;
    margin: 48px auto;
  }
  .p_empty {
    width: auto;
    height: 25px;
    opacity: 0.85;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
    line-height: 25px;
    margin-bottom: 64px;
    text-align: center;
  }
  .proxy_empty {
    display: flex;
    align-items: baseline;
    margin-left: 35px;
  }
  .title {
    width: auto;
    height: 25px;
    opacity: 0.85;
    font-size: 18px;
    font-weight: bold;
    line-height: 25px;
    color: #000000;
    margin-left: 16px;
  }
  .dialog {
    width: auto;
    margin-left: 156px;
    p {
      width: auto;
      height: 24px;
      opacity: 0.85;
      font-size: 14px;
      font-weight: 500;
      color: #000000;
      line-height: 24px;
      padding-bottom: 24px;
    }
    .a_style {
      font-size: 12px;
      font-weight: 400;
      color: #227FFE;
      line-height: 17px;
    }
    .detail {
      width: auto;
      height: 24px;
      font-size: 16px;
      font-weight: 500;
      text-align: left;
      color: #227FFE;
      line-height: 24px;
      cursor: pointer;
    }
    .detail1 {
      width: auto;
      height: 24px;
      font-size: 16px;
      font-weight: 500;
      text-align: left;
      line-height: 24px;
    }
  }
}
::v-deep .el-table__expanded-cell{
  z-index: 100;
  padding: 0;
}
// ::v-deep .el-table__body-wrapper {
//   overflow: hidden;
// }
</style>
